import React from "react";
import { PageSeo } from "../components/PageSeo";
import { ContactSection } from "../components/ContactSection";

export function KontaktPage() {
  return (
    <>
      <PageSeo
        title="Kontakt | RESTORAN KRČMA Kragujevac"
        description="Kontaktirajte RESTORAN KRČMA u Kragujevcu: telefon, adresa i radno vreme."
        keywords="kontakt restoran Kragujevac, restoran Krčma adresa, rezervacija restoran Kragujevac"
        path="/kontakt"
      />
      <ContactSection />
    </>
  );
}

